import styled from "styled-components";
import { ButtonSettings, Text, Heading } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const BuyAssetPageStyled = styled.section`
  width: 100%;
  height: 100%;
  position: relative;
  // text-align: center;
  display: flex;
  align-items: center;
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    // background-color: #000;
    // opacity: 0.3;
    background: ${props => props.background && `url(${props.background}) no-repeat`};
    background-size: contain;
  }
`;

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: ${props =>
    props.theme.spacing.large};
  top: 4.5rem;
`;

export const LandingPageStyled = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  background: ${props => props.background && `url(${props.background}) 0 0 / cover no-repeat`};
  // padding: 0 3rem;
`;
export const TextStyled = styled(Text)`
  font-weight: normal;
  font-size: 0.928rem;
  margin-top: 1rem;
  color: ${props => props.theme.color.greyLight};
`;

export const BuyBrandsContainer = styled.div`
position: relative;
width: 56%;
border: 0.125rem solid rgba(209,211,212,0.3);
border-radius: 0.5rem;
// border-radius: ${props => props.theme.font.size.default};
padding: 1.4rem 1.625rem;
height: auto;
margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 2rem;
// background-color: rgba(8, 33, 37, 0.97);
background-color: rgba(0, 0, 0, 0.8);
color: ${props => props.theme.color.white};
box-shadow: 0 32px 48px 0 rgba(0, 0, 0, 0.5);
margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: auto;
  // display: flex;
  // padding-top: 10rem;
  // justify-content: space-between;
`;

export const BodySection = styled.div`
  display: flex;
  justify-content: space-between;
  // padding-top: 1rem;
  padding: 1rem 0rem;
`;

export const FooterSections = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
`;

export const HeadingBorder = styled.div`
  height: 2px;
  width: 100%;
  opacity: 0.3;
  background-color: ${props => props.theme.color.greyLight};
  position: absolute;
  // margin: 1rem 0rem;
  ${props =>
    props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT
      ? `transform: translateX(2.8%)`
      : `transform: translateX(-2.8%)`};
  box-sizing: border-box;
`;

export const FirstContainerStyle = styled.div`
  display: block;
  width: 31%;
`;
export const ImageStyle = styled.div`
  height: 12.577rem;
  width: 22.36rem;
  border-radius: 0.5rem;
  margin: 0 auto;
`;

export const DetailsContainerStyle = styled.div`
  // width: 50%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  padding: 1rem;
  margin: auto 0;
`;

export const HeadingStyle = styled.div`
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  padding: 0rem 0rem 1rem;
`;

export const BorderDiv = styled.div`
  height: 2px;
  width: 100%;
  opacity: 0.3;
  background-color: ${props => props.theme.color.greyLight};
  margin: 1rem 0rem;
`;

export const ImageWrapper = styled.img`
  height: 8rem;
`;

export const PriceContainer = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
  h1 {
    // margin-top: 0rem;
  }
`;

export const HeadingStyled = styled(Heading)`
  font-size: 1.289rem !important;
  font-weight: normal !important;
`;
export const PriceStyled = styled(Heading)`
  font-size: 1.5rem !important;
  font-weight: normal !important;
`;

export const TextDetailsStyled = styled(Text)`
  font-size: 1.75rem;
  padding-top: 2rem;
  margin-bottom: 1.8rem;
`;

export const StepContainer = styled.span`
  vertical-align: middle;
  width: 100%;
  // margin-bottom: ${props => (props.userLocale === "ar" ? "0px" : props.theme.spacing.xsmall)};
  display: block;
`;

export const StepNumber = styled.div`
  border-radius: 50%;
  display: inline-block;
  width: calc(3.918rem);
  height: calc(3.918rem);
  padding: 0.5rem ${props => props.theme.spacing.xsmall};
  border: 3px solid rgba(${props => props.theme.color.primaryRGB}, 0.4);
  color: #000000;
  background-color: #FFFFFF;
  text-align: center;
  font-size: 2.062rem;
  margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")}: 0.8rem;
`;

export const StepText = styled(Text)`
  vertical-align: middle;
  font-weight: bold;
  display: inline-block;
  // margin-bottom: 1.8rem;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  font-size: 1.443rem;
`;

export const QrCodeStyle = styled.div`
  // width: 20vw;
  // height: 20vw;
  // width: 18.351rem;
  // height: 18.351rem;
  // border: 0.8rem solid #fff;
  // border-radius: 0.8rem;
  // position: absolute;
  // top: calc(${props => props.theme.spacing.xlarge} * 4);
  // ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left: 7.3rem" : "right: 9.3rem")};
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};
  // margin-top: 9rem;
  svg {
    width: 20rem;
    height: 20rem
    border: 0.8rem solid #fff;
    border-radius: 0.8rem;
  }
`;

export const QRCode = styled.img`
  width: 20vw;
  height: 20vw;
  border: 20px solid #fff;
  border-radius: ${props => props.theme.spacing.small};
  // position: absolute;
  top: calc(7.5rem * 3);
  // ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left: 7.3rem" : "right: 6.3rem")};
  // text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")};

`;

export const ButtonWrapper = styled.div``;

export const ButtonModalStyled = styled(ButtonSettings)`
  // display: block;
  // margin-top: ${props => props.theme.spacing.xsmall};
  width: 100%;
  // margin-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right: 70rem" : "left: 68rem")};
`;

export const ButtonModelWrapper = styled.div`
  width: 34%;
  text-align: ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right")};
  margin: auto 0;
`;

export const FooterTextStyled = styled(Text)`
  font-weight: normal;
  font-size: 1.5rem;
  // margin-top: 1rem;
  color: ${props => props.theme.color.greyLight};
  width: 55%;
  line-height: 1.2;
`;
